import createApp from './app.js'

import messagingService from './service.messaging.js'
import analyticsService from './service.analytics.js'

const appConfig = {"apiKey":"AIzaSyDZqdJvu1zAHXc4TEbBRpmBqZr37Yk9rE4","authDomain":"uberemtasksapp.firebaseapp.com","projectId":"uberemtasksapp","storageBucket":"uberemtasksapp.appspot.com","messagingSenderId":"290266381490","appId":"1:290266381490:web:79be62122738cac7039dab","measurementId":"G-KBFPWZT0F8"}

export default async (ctx, inject) => {
  const { firebase, session } = await createApp(appConfig, ctx)

  let servicePromises = []

  if (process.client) {
    servicePromises = [
      messagingService(session, firebase, ctx, inject),
      analyticsService(session, firebase, ctx, inject),

    ]
  }

  const [
    messaging,
    analytics
  ] = await Promise.all(servicePromises)

  const fire = {
    messaging: messaging,
    analytics: analytics
  }

    inject('fireModule', firebase)
    ctx.$fireModule = firebase

  inject('fire', fire)
  ctx.$fire = fire
}

function forceInject (ctx, inject, key, value) {
  inject(key, value)
  const injectKey = '$' + key
  ctx[injectKey] = value
  if (typeof window !== "undefined" && window.$nuxt) {
  // If clause makes sure it's only run when ready() is called in a component, not in a plugin.
    window.$nuxt.$options[injectKey] = value
  }
}